import { ActionEnum } from "../action.enum";
import { Widget } from '../../models/dashboard/widget.model';

export namespace DashboardActions {

  export class EnterEditMode {
    static readonly type = ActionEnum.DASHBOARD_ENTER_EDIT_MODE;
  }

  export class ExitEditMode {
    static readonly type = ActionEnum.DASHBOARD_EXIT_EDIT_MODE;
  }

  export class GetWidgets {
    static readonly type = ActionEnum.DASHBOARD_GET_WIDGETS;
  }

  export class SaveWidgets {
    static readonly type = ActionEnum.DASHBOARD_SAVE_WIDGETS;

    constructor(public widgets: Widget[]) {}
  }

  export class SaveWidgetsSuccessful {
    static readonly type = ActionEnum.DASHBOARD_SAVE_WIDGETS_SUCCESSFUL;

    constructor(public changedWidgetIds: Set<string>) {}
  }
}
